import React from 'react';

function About() {
  return (
    <section id="about" className="bg-gray-950 py-32">
      <div className="luxury-container">
        <h2 className="text-center text-luxury text-5xl mb-12 tracking-widest elegant-text hover-glow">
          ABOUT LUXE JEWELS
        </h2>
        <p className="text-gray-300 text-lg text-center max-w-3xl mx-auto leading-relaxed tracking-wide font-light elegant-text hover-glow">
          Since 1995, Luxe Jewels has been the premier destination for those who appreciate true elegance and exceptional craftsmanship. 
          Our collection features carefully curated pieces from master artisans around the world, each telling a unique story of 
          beauty and tradition. We are committed to delivering not just jewelry, but timeless pieces that become treasured heirlooms 
          passed down through generations.
        </p>
      </div>

      {/* Features Section */}
      <section className="bg-gradient-to-r from-gray-900 via-gray-950 to-gray-900 py-32 border-y border-yellow-600/20 mt-16">
        <div className="luxury-container">
          <h2 className="text-center text-luxury text-5xl mb-16 tracking-widest hover-glow">
            WHY CHOOSE LUXE JEWELS
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {[
              { title: 'AUTHENTIC GEMS', desc: 'Every piece is certified and authenticated' },
              { title: 'MASTER CRAFTED', desc: 'Handcrafted by expert artisans worldwide' },
              { title: 'LIFETIME GUARANTEE', desc: 'Quality and beauty assured for generations' },
            ].map((feature, idx) => (
              <div 
                key={idx} 
                className="text-center card-luxury-3d p-8 bg-gray-950/50 rounded-sm border border-yellow-600/20 hover:border-yellow-600/50"
              >
                <h3 className="text-2xl font-bold text-yellow-400 mb-4 tracking-widest hover-glow">
                  {feature.title}
                </h3>
                <p className="text-gray-400 tracking-wide font-light hover-glow">
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-32">
        <div className="luxury-container">
          <h2 className="text-center text-luxury text-5xl mb-16 tracking-widest hover-glow">
            WHAT OUR CLIENTS SAY
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                name: "Sarah Johnson",
                role: "Fashion Designer",
                quote: "Luxe Jewels transformed my vision into reality. The craftsmanship is unparalleled, and the attention to detail is exquisite.",
                rating: 5
              },
              {
                name: "Michael Chen",
                role: "Business Executive",
                quote: "I've been collecting from Luxe Jewels for years. Each piece tells a story and becomes a cherished part of my collection.",
                rating: 5
              },
              {
                name: "Emma Rodriguez",
                role: "Art Curator",
                quote: "The elegance and sophistication of Luxe Jewels pieces are unmatched. They truly understand the art of luxury jewelry.",
                rating: 5
              }
            ].map((testimonial, idx) => (
              <div key={idx} className="bg-gray-900/50 p-8 rounded-lg border border-yellow-600/20 hover:border-yellow-500/40 transition-all duration-300 hover-glow">
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <span key={i} className="text-yellow-400 text-lg">★</span>
                  ))}
                </div>
                <p className="text-gray-300 italic mb-6 leading-relaxed">"{testimonial.quote}"</p>
                <div>
                  <h4 className="text-yellow-400 font-semibold">{testimonial.name}</h4>
                  <p className="text-gray-500 text-sm">{testimonial.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Social Proof Section */}
      <section className="py-32 bg-gradient-to-r from-gray-900 via-gray-950 to-gray-900 border-y border-yellow-600/20">
        <div className="luxury-container">
          <h2 className="text-center text-luxury text-5xl mb-16 tracking-widest hover-glow">
            TRUSTED BY ICONS
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            {[
              { name: "Celebrity Choice", desc: "Preferred by Hollywood stars", icon: "✯" },
              { name: "Royal Warrant", desc: "Official supplier to nobility", icon: "♔" },
              { name: "Museum Collections", desc: "Featured in major museums", icon: "❖" },
              { name: "Award Winning", desc: "Recognized by industry experts", icon: "❇" }
            ].map((item, idx) => (
              <div key={idx} className="text-center card-luxury-3d p-6 bg-gray-950/50 rounded-sm border border-yellow-600/20 hover:border-yellow-600/50">
                <div className="text-4xl mb-4">{item.icon}</div>
                <h3 className="text-xl font-bold text-yellow-400 mb-2 tracking-widest hover-glow">
                  {item.name}
                </h3>
                <p className="text-gray-400 tracking-wide font-light hover-glow">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center">
            <p className="text-gray-300 text-lg italic mb-8">
              "Luxe Jewels has been the choice of discerning individuals worldwide for over three decades,
              crafting pieces that become family heirlooms passed down through generations."
            </p>
            <p className="text-yellow-400 font-semibold">- International Jewelry Council</p>
          </div>
        </div>
      </section>
    </section>
  );
}

export default About;
